import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-tool-section',
    templateUrl: './tool-section.component.html',
    styleUrls: ['./tool-section.component.scss'],
    standalone: false
})
export class ToolSectionComponent implements OnInit {

  @Input() title: string;
  @Input() description: string;

  icon: boolean;
  @Input('icon') set setIcon(attribute: boolean | '') {
    this.icon = attribute === '' || attribute;
  }

  isHeader: boolean;
  @Input('isHeader') set setIsHeader(attribute: boolean | '') {
    this.isHeader = attribute === '' || attribute;
  }

  constructor() { }

  ngOnInit() { }

}
